<template>
  <div
    class="group mt-[2px] text-right text-sm font-bold text-orange/80 md:text-sm md:font-semibold [&.is-instock]:opacity-100"
  >
    <span
      v-if="
        option.inStock &&
        option.stockData < LOW_STOCK_THRESHOLD &&
        option.inventory_management === 'shopify'
      "
      class="whitespace-nowrap"
      >{{ t('product.stock.text_low_stock') }}</span
    >
    <template v-if="!option.inStock">
      <span
        class="whitespace-nowrap text-secondary group-[&.is-instock]:hidden"
        >{{ t('product.stock.text_oos') }}</span
      >
    </template>
  </div>
</template>

<script setup>
import { useTranslations } from '@/shared/composables/useTranslations';
import { LOW_STOCK_THRESHOLD } from '@/shared/constants/constants';

const { t } = useTranslations();

defineProps({
  option: {
    type: Object,
    required: true
  }
});
</script>
